export default {"src":"/_next/static/media/ooo-empty.ed657c7b.svg","height":25,"width":25};